// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"VY-z","sponsoredTooltipWrapper":"WY-z","sponsoredTooltip":"XY-z","newCard":"YY-z"};